import { render, staticRenderFns } from "./PropertiesPaymentListTable.vue?vue&type=template&id=cbd2147c"
import script from "./PropertiesPaymentListTable.vue?vue&type=script&lang=js"
export * from "./PropertiesPaymentListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports